export const GOOGLE_FONTS = "google_fonts";
export const INSTAGRAM_SOURCES = "instagram_sources";
export const INSTAGRAM_IMAGES = "instagram_images";
export const DESIGN_STORE = "design_store";
export const EXPORTED_DESIGNS = "exported_designs";
export const USER_SITES = "user_sites";
export const SHOWIT_LIBRARY_DESIGNS = "showit_library_designs";
export const USER_LIBRARY_DESIGNS = "user_library_designs";
export const USER_BLOG_DOMAINS = "user_blog_domains";
export const USER_DOMAINS = "user_domains";
export const USER_AVAILABLE_DOMAINS = "user_available_domains";
export const ACCESSIBLE_ACCOUNTS = "accessible_accounts";
export const SITE_DESIGNS_FOLDERS = "site_designs_folders";
export const USER_ASSETS = "user_assets";
export const ASSET_FOLDERS = "asset_folders";
export const SITE = "site";
export const ACCOUNT = "account";
export const RENDERER = "renderer";
export const RENDERER_LOCK_ELIGIBILITY = "renderer_lock_eligibility";
export const BDOW_SITES = "bdow_sites";
export const PEXELS_PHOTOS = "pexels_photos";
